module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-46c6e1c2e7cdd852a02ef8c0c779373d.png";